import React, { Fragment, useState } from 'react';
import classNames from 'classnames';

import { CLUSTER_HEADER_CATEGORY } from '../../../utils/constant';
import CareerClusterHeaderTitle from '../careerClusterHeader/CareerClusterHeaderTitle';
import SearchBar from '../common/SearchBar';
import SubHeader from '../common/SubHeader';

const MajorClusterHeader = ({ subPageName, ...data }) => {
  const { major } = data.criteria;
  const { dynamicPage } = data;

  let subPageText = subPageName;
  let title = `${major} Major`;

  switch (subPageName) {
    case 'salary':
      subPageText = '';
      title = `Average ${major} Major Salary`;
      break;
    case 'best-jobs':
      subPageText = '';
      title = `Best jobs for ${major?.toLowerCase?.()} majors`;
      break;
    case 'best-colleges':
      subPageText = '';
      title = `${major} Major Best Colleges`;
      break;
    default:
      break;
  }

  const [pageTitle, setPageTitle] = useState('');

  return (
    <Fragment>
      <div className="d-flex flex-column-reverse flex-lg-row align-items-start container major-search">
        <CareerClusterHeaderTitle
          subPageName={subPageText}
          title={title}
          getPageTitle={(_pageTitle) => setPageTitle(_pageTitle)}
        />
        <SearchBar
          dynamicPage={dynamicPage}
          subPageName={subPageName}
          clusterCategory={CLUSTER_HEADER_CATEGORY.MAJOR}
          className={classNames('z-mt-12 z-mb-20 z-mb-lg-0 z-ml-lg-20', {
            'z-mt-lg-44': pageTitle.length > 40,
            'z-mt-lg-40': pageTitle.length <= 40,
          })}
        />
      </div>
      <div className="sub-header-container">
        <SubHeader {...data} />
      </div>
    </Fragment>
  );
};

export default MajorClusterHeader;
